import type { AvatarGesture, AvatarLoop } from "./avatar-clips";

export type Reaction =
  | { kind: "gesture"; name: AvatarGesture }
  | { kind: "hold"; name: AvatarLoop }
  | { kind: "release" };

type Listener = (reaction: Reaction) => void;

const listeners = new Set<Listener>();

/**
 * Orla answers the whole page, not only the part of it she sits in: hovering a link in the
 * navigation makes her react. Those are far apart in the tree, so they speak through this
 * one small channel rather than through props threaded across the site.
 */
export const reactions = {
  subscribe(listener: Listener): () => void {
    listeners.add(listener);
    return () => listeners.delete(listener);
  },
  send(reaction: Reaction): void {
    for (const listener of listeners) listener(reaction);
  },
};
